import React from "react";
import { Box, EmptyState } from "@tiny/components";
import Search from "@tiny/icons/generated/Search";

import { useSearchPanelContent } from "./SearchPanelContent.hooks";

function SearchPanelContent<T>() {
  const {
    data,
    idKey,
    ContentComponent,
    onToggleSelect,
    selected,
    selectedDisabled,
    mdUp,
    moreActions,
    isEmpty,
    emptyStateTitle,
    emptyStateMessage,
  } = useSearchPanelContent<T>();

  return (
    <Box pl={mdUp ? 6 : 4} pr={mdUp ? 6 : 4}>
      {isEmpty ? (
        <Box bgcolor="grey.50" pt={10} pb={10}>
          <EmptyState
            title={emptyStateTitle}
            message={emptyStateMessage}
            icon={<Search />}
            iconColor="primary"
            circleColor="white"
            align="center"
          />
        </Box>
      ) : (
        <ContentComponent
          data={data}
          idKey={idKey}
          onToggleSelect={onToggleSelect}
          selected={selected}
          selectedDisabled={selectedDisabled}
          moreActions={moreActions}
        />
      )}
    </Box>
  );
}

export default SearchPanelContent;
